import { useEffect, useRef, useState } from "react";
import client from "@/lib/api";
import { ChevronDown, Layers } from "lucide-react";

// Shared, lightly cached list of property groups (refetched at most every 30s).
let cache = { at: 0, p: null };
export const invalidatePropertyGroups = () => { cache = { at: 0, p: null }; };
export function fetchPropertyGroups() {
  if (!cache.p || Date.now() - cache.at > 30000) {
    cache = { at: Date.now(), p: client.get("/property-groups").then((r) => r.data).catch(() => []) };
  }
  return cache.p;
}

export function PropertyGroupMenu({ value, validIds, onAdd, testid }) {
  const [open, setOpen] = useState(false);
  const [groups, setGroups] = useState(null);
  const ref = useRef(null);
  useEffect(() => { fetchPropertyGroups().then(setGroups); }, [open]);
  useEffect(() => {
    const h = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);
  const pick = (g) => {
    const ids = g.property_ids.filter((id) => (!validIds.size || validIds.has(id)) && !value.includes(id));
    onAdd(ids);
    setOpen(false);
  };
  return (
    <div ref={ref} className="relative">
      <button type="button" onClick={() => setOpen((v) => !v)} data-testid={`${testid}-groups`}
        className="flex items-center gap-0.5 text-[11px] font-semibold text-sky-600 hover:underline">
        <Layers className="h-3 w-3" />Select Group<ChevronDown className="h-3 w-3" />
      </button>
      {open && (
        <div className="absolute right-0 top-full z-50 mt-1 w-56 rounded-lg border border-slate-200 bg-white py-1 shadow-lg" data-testid={`${testid}-groups-menu`}>
          {groups === null ? <p className="px-3 py-2 text-xs text-slate-400">Loading…</p> : !groups.length ? (
            <p className="px-3 py-2 text-xs text-slate-400">No groups yet — add them in System Settings → Property Groups</p>
          ) : [{ id: "all", name: "All Groups", property_ids: [...new Set(groups.flatMap((g) => g.property_ids))], all: true }, ...groups].map((g) => (
            <button key={g.id} type="button" onClick={() => pick(g)} data-testid={`${testid}-group-${g.id}`}
              className={`flex w-full items-center justify-between px-3 py-2 text-left text-sm hover:bg-sky-50 ${g.all ? "border-b border-slate-100 font-semibold text-sky-700" : "text-slate-700"}`}>
              <span className="truncate">{g.name}</span><span className="ml-2 shrink-0 text-xs text-slate-400">{g.property_ids.length}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
